import { InjectionToken, Signal } from '@angular/core';

export interface TabsHost<T = unknown> {
  readonly value: Signal<T | null>;
  selectValue(value: T): void;
}

export const TABS_HOST = new InjectionToken<TabsHost<unknown>>('TABS_HOST');
